import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Col, Row } from "react-bootstrap";
import DropDownItem from "../DropDownComponent/DropDown";
import TextInput from "../TextInputComponent/TextInput";
import Button from "../ButtonComponent/Button";
import DatePicker from "react-multi-date-picker";
import CalenderIcon from "../../assets/images/calenderIcon.svg";
import CloseButton from "../../assets/images/Icons/closeIcon.svg";
import Contents from "../../constants/contentFile.json";
import { Spinner } from "react-bootstrap";
import "./zoneFilter.css";

const ZoneFilter = ({
  show,
  setShow,
  filterZone,
  setFilterZone,
  filterCategory,
  setFilterCategory,
  filterFromDate,
  setFilterFromDate,
  filterToDate,
  setFilterToDate,
  onSubmit,
  spinnerStatus,
  visibleZone,
  setVisibleZone,
  visibleCategory,
  setVisibleCategory,
  reportFilterCriteria, // extended stay
  timeInterval, // time interval state
  setTimeInterval, // time interval set state
  submitTimeInterval, // time interval filter submit
  categoryList,
}) => {
  const [validDates, setValidDates] = useState(true);

  const handleClose = () => {
    setVisibleZone({ id: false, name: "All Zones" });
    setVisibleCategory({ id: false, name: "All Categories" });
    setTimeInterval({ id: "select", name: "Select time interval" });
    setValidDates(true);
    setShow(false);
  };

  const zoneList = [
    { id: false, name: "All Zones" },
    { id: "ZONE1", name: "Zone 1" },
    { id: "ZONE2", name: "Zone 2" },
  ];
  // const categoryList = [
  //   { id: false, name: "All Categories" },
  //   ...Contents.zoneFilterCategory,
  // ];

  // time interval select
  const timeIntervalList = [
    { id: "select", name: "Select time interval" },
    { id: 12, name: "12 hours" },
    { id: 24, name: "24 hours" },
  ];
  return (
    <Modal className="zone-filter" show={show} centered>
      <div className="filter-outer-container">
        <span>
          <img
            onClick={() => handleClose()}
            className="close-btn"
            src={CloseButton}
          ></img>
        </span>
        <Col
          lg={12}
          className={
            reportFilterCriteria === "extendedStay" ? "display-none" : ""
          }
        >
          <Row>
            <Col lg={12} className="filterText">
              Filter
            </Col>
            <Col className="mb-4" lg={12}>
              <DropDownItem
                selectedItem={visibleZone}
                setSelectedItem={setVisibleZone}
                categoryRequired={false}
                list={zoneList}
              />
            </Col>
            <Col className="mb-4 category-dropDown" lg={12}>
              <DropDownItem
                selectedItem={visibleCategory}
                setSelectedItem={setVisibleCategory}
                categoryRequired={false}
                list={categoryList}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <DatePicker
                showOtherDays
                className="date-picker"
                format="YYYY-MM-DD"
                render={(value, openCalendar) => {
                  return (
                    <div onClick={openCalendar}>
                      <div
                        className={
                          validDates
                            ? "fromDateContainerReportBox"
                            : "fromDateContainerReportBox not-valid"
                        }
                      >
                        <div className="fromToContainerReportBox">
                          <span className="selectTextReportBox">
                            {filterFromDate === ""
                              ? "From Date"
                              : filterFromDate}
                            {setFilterFromDate(value)}
                          </span>
                        </div>
                        <div className="calenderReportBox">
                          <img src={CalenderIcon} />
                        </div>
                      </div>
                    </div>
                  );
                }}
              />
            </Col>
            <Col lg={6}>
              <DatePicker
                showOtherDays
                format="YYYY-MM-DD"
                render={(value, openCalendar) => {
                  return (
                    <div onClick={openCalendar}>
                      <div
                        className={
                          validDates
                            ? "fromDateContainerReportBox"
                            : "fromDateContainerReportBox not-valid"
                        }
                      >
                        <div className="fromToContainerReportBox">
                          <span className="selectTextReportBox">
                            {filterToDate === "" ? "To Date" : filterToDate}
                            {setFilterToDate(value)}
                          </span>
                        </div>
                        <div className="calenderReportBox">
                          <img src={CalenderIcon} />
                        </div>
                      </div>
                    </div>
                  );
                }}
              />
            </Col>
            <Col lg={12} className="mt-3">
              <Button
                onClick={() => {
                  if (
                    filterFromDate != "" &&
                    filterToDate != "" &&
                    filterFromDate <= filterToDate
                  ) {
                    setValidDates(true);
                    setFilterZone(visibleZone);
                    setFilterCategory(visibleCategory);
                    onSubmit(
                      1,
                      visibleZone.id,
                      visibleCategory.id,
                      filterFromDate + " " + "00:00:00",
                      filterToDate + " " + "23:59:59"
                    );
                  } else {
                    setValidDates(false);
                  }
                }}
                text={spinnerStatus ? <Spinner size="sm" /> : "SUBMIT"}
              ></Button>
            </Col>
          </Row>
        </Col>
        <Col
          lg={12}
          className={
            reportFilterCriteria === "extendedStay"
              ? "show-button"
              : "display-none"
          }
        >
          <Row>
            <Col lg={12} className="filterText">
              Filter
            </Col>
            <Col className="mb-4" lg={12}>
              <DropDownItem
                selectedItem={timeInterval}
                setSelectedItem={setTimeInterval}
                categoryRequired={false}
                list={timeIntervalList}
              />
            </Col>
            <Col lg={12} className="mt-2">
              <Button
                text={spinnerStatus ? <Spinner size="sm" /> : "SUBMIT"}
                onClick={submitTimeInterval}
              ></Button>
            </Col>
          </Row>
        </Col>
      </div>
    </Modal>
  );
};

export default ZoneFilter;
